  let checkCount = 0;
  const maxChecks = 20;
  const checkInterval = 300;

  const intervalId = setInterval(function() {

    const offerCartRow = document.querySelector('.Offer-cart__row');
    if (offerCartRow) {
      
      const productTitle = document.querySelector('h1.Product__title');
    
      if (productTitle) {
        const titleText = productTitle.innerText.toLowerCase();
        
        if (titleText.includes('trial') || titleText.includes('trials')) {
          const productPrice = document.querySelector('span.Product__price');
          if (productPrice) {
            productPrice.innerText = 'FREE';
          }
        }
      }
      clearInterval(intervalId);
    } else {
      checkCount++;

      if (checkCount >= maxChecks) {
        console.log('Elemento de Upsell não encontrado');
        clearInterval(intervalId);
      }
    }
  }, checkInterval);

